"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _cardValidator = _interopRequireDefault(require("card-validator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 *
 * @param {String} cardNumber - card number to validate
 * @returns cardType, if card is valid, cvv length, and card length
 */
var GetCardInfo = function GetCardInfo() {
  var cardNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var formattedNumber = cardNumber.replace(/\D/g, '');
  var cvvLength = 3;
  var cardType = '';
  var cardLength = 16;

  var numberValidation = _cardValidator["default"].number(formattedNumber);

  var isValid = numberValidation.isValid;
  var card = numberValidation.card;

  if (card) {
    cardType = card.type;

    if (cardType === 'visa' || cardType === 'discover') {
      cardType = cardType.charAt(0).toUpperCase() + cardType.slice(1);
    }

    if (cardType === 'master-card' || cardType === 'mastercard') {
      cardType = 'MasterCard';
    }

    if (cardType === 'american-express') {
      cardType = 'AmericanExpress';
    }

    cvvLength = card.code.size;
    cardLength = card.lengths[0];
  }

  return {
    cardType: cardType,
    isValid: isValid,
    cvvLength: cvvLength,
    cardLength: cardLength
  };
};

var _default = GetCardInfo;
exports["default"] = _default;